import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectIncidentsRedesignEnabled } from 'containers/App/selectors'

import { epicsErrorHandler } from '../../../epics'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'
import { QUICK_FILTERS_CHANGE } from '../QuickFilters/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SET_DETECTED_BY_FILTER,
  SORTING_CHANGE,
} from './constants'
import {
  selectDateFilter,
  selectDetectedByFilter,
  selectSortingBy,
  selectSortingDirection,
} from './selectors'

const fetchDataEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      SEARCH_CHANGE,
      PAGINATE_CHANGE,
      QUICK_FILTERS_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      GENERAL_FILTER_CHANGE,
      SET_DETECTED_BY_FILTER,
      DATE_FILTER_CHANGE,
      SORTING_CHANGE
    ),
    filter((action) => {
      if (
        action.type === QUICK_FILTERS_CHANGE ||
        action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
      )
        return matchURL(URL_CONST.incidents.reported)
      return true
    }),
    switchMap(() => {
      const state = state$.value
      const redesignOn = selectIncidentsRedesignEnabled(state)
      const feDateRange = redesignOn ? getRangeFromDateFilter(selectDateFilter(state)) : undefined
      return api.resolutionCenter
        .getReportedIncidents(
          state.resolutioncenter.reportedIncidents.page || 1,
          state.resolutioncenter.reportedIncidents.search,
          state.resolutioncenter.reportedIncidents.generalFilter,
          selectDetectedByFilter(state)?.map((elem) => elem.value),
          state.resolutioncenter.quickFilters.quickFilters,
          state.partnerOptions.selectedCompany?.value,
          feDateRange,
          selectSortingBy(state),
          selectSortingDirection(state)
        )
        .pipe(
          map((response) => fetchDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
          takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(fetchDataEpic)
